export default "__VITE_ASSET__3b039ff4__"